import { SxProps, styled } from "@mui/system";
import React from "react";

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  sx?: SxProps;
}

// styled() util adds support for sx prop
const StyleableImage = styled("img")<ImageProps>(
  {}
) as React.ElementType<ImageProps>;

const Image = (
  { sx, ...props }: ImageProps,
  ref: React.Ref<HTMLImageElement>
) => <StyleableImage ref={ref} sx={sx} {...props} />;

export default React.forwardRef(
  Image
) as React.ForwardRefExoticComponent<ImageProps>;
